<script setup></script>

<template>
  <div
    class="h-full min-h-screen w-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300"
  >
    <slot />
  </div>
</template>
